// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-block[data-v-b41c599e]{padding:0 40px}.email-block .font16[data-v-b41c599e]{font-size:16px;word-break:normal}.v-application .email-block .v-btn[data-v-b41c599e]{text-transform:unset}.v-application .email-block .logo-color[data-v-b41c599e]{color:#0091ff!important}", ""]);
// Exports
module.exports = exports;
